import { render, staticRenderFns } from "./beBestAndWorst.vue?vue&type=template&id=2b328e76&"
import script from "./beBestAndWorst.vue?vue&type=script&lang=js&"
export * from "./beBestAndWorst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports